import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../rootStore";

const createApplicationSelector = createDraftSafeSelector.withTypes<RootState>();

export const loadedSteppersSelector = (state: RootState) => state.application.loadedSteppers;
export const allPossibleSteppersSelector = (state: RootState) => state.application.allPossibleSteppers;
export const isAppReadySelector = (state: RootState) => state.application.isAppready;

const allSteppersLoadedSelector = createApplicationSelector(
    [loadedSteppersSelector, allPossibleSteppersSelector],
    (loadedSteppers, allPossibleSteppers) => loadedSteppers.length === allPossibleSteppers.length,
);

export const isApplicationReadySelector = createApplicationSelector(
    [allSteppersLoadedSelector, isAppReadySelector],
    (steppersLoaded, appReady) => steppersLoaded && appReady === true,
);
